module.exports = __webpack_public_path__ + "static/media/char-bg.f3f47060.png";